import { RedoOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import React, { useState, useEffect, useContext } from 'react'
import iconEmpty from 'icons/createproject/supportneed.svg'
import styled from 'styled-components'
import { getCookie } from 'helper/cookie'
import {
  getTreeKpitype,
  getTreeKpitypeV3,
  getKpitypeByCompanyId,
  getKpitypeByCompanyIdV3,
  getKpitypeInfoByCompanyId,
  addKpitype,
  updateKpitype,
  updateKpitypeV2,
  getResultCompanyV2,
  addKpitypeV2,
} from 'api/MasterData/kpitype'
import DeleteKpitype from 'common/Management/delete'
import Tree from '../Tree/Company/TreeKpitype'
import {
  Button,
  Drawer,
  Form,
  Row,
  Col,
  Input,
  Select,
  Table,
  Space,
  Alert,
  Modal,
  TreeSelect,
  Tag,
  Checkbox,
  Switch,
  Radio,
} from 'antd'
import { get, set, toUpper } from 'lodash'
import lang from 'lang/en'
//checkrole
import { CounterContext } from 'redux/Golbalvalues'
import FilterSearchTree from './FilterSearchTree'
import { use } from 'react'
const KPIContainer = styled.div``
const Header = styled.div``
const Body = styled.div``
const EmptyContainer = styled.div``
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;

  .ant-checkbox-wrapper {
    margin-bottom: 0px !important;
    margin: 0px !important;
  }
`

const initalState = {
  data: [],
  isLoading: true,
  company: 1,
  pagination: {
    pageSize: 10, //จำนวนข้อมูลในหน้านั้น
    total: 0, //ข้อมูลทั้งหมด
    current: 1,
    showQuickJumper: 1,
    // showSizeChanger: true,
    // showTotal: (total, range) => showToalPagination(total, range),
  },
}
const showToalPagination = (total, range) => {
  return <p className="small-show-total">{`${range[0]}-${range[1]} of ${total}`}</p>
}
const KPI = (props) => {
  // const { dataCompany } = props
  const [dataCompany, setResultscompany] = useState([])
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const word = lang[language]
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [pagination, setPagination] = useState(initalState.pagination)
  const [data, setData] = useState(initalState.data)
  const [titleDrawer, setTitleDrawer] = useState('')
  const [stateDrawer, setStateDrawer] = useState('')
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [dataEdit, setDataEdit] = useState()
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()

  const [switchValue, setSwitchValue] = useState(true)
  const [mainKpiValue, setMainKpiValue] = useState(false)
  const [calculateType, setCalculationType] = useState('cumulative')

  //search
  const [searchedColumn, setSearchedColumn] = useState('')
  const [searchText, setSearchText] = useState('')

  //tree
  const [dataTree, setDataTree] = useState(initalState.data)
  const [level, setLevel] = useState(1)
  const [level_ID, setLevel_ID] = useState(0)
  const [checkByID, setCheckByID] = useState()
  const [companyID, setCompanyID] = useState()
  const [checkChangeTable, setCheckChangeTable] = useState(0)
  //เช็คจังหวะแรก
  const [firsttimein, setFirsttimein] = useState(true)
  const [firstTimeFilter, setFirstTimeFilter] = useState(true)
  // เช็คไอดีซ้ำ
  const [hiddenError, setHiddenError] = useState(true)

  const [wordERR, setWordERR] = useState('')

  // KPI Tree Select
  // ใช้สำหรับจัดการการเลือก KPI ใน TreeSelect
  const [selectedKPIs, setSelectedKPIs] = useState([])

  const [filteredKPIs, setFilteredKPIs] = useState([])
  const [filterDataKPI, setFilterDataKPI] = useState([])
  const [filteredTreeKPI, setFilteredTreeKPI] = useState([])

  const textd = word['KPI_Finance_Type'] || 'KPI Types'

  const { adminPermission } = useContext(CounterContext)
  //check permission
  const [disablePage, setDisablePage] = useState(false)

  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  // const fetchAllKPIData = async () => {
  //   setIsLoading(true)

  //   try {
  //     if (dataTree && dataTree.length > 0) {
  //       const fetchPromises = dataTree.map((company) =>
  //         getKpitypeByCompanyId({
  //           company_id: company.id,
  //           token: token,
  //         })
  //           .then((response) => {
  //             if (response.status === 200) {
  //               return response.data || []
  //             }
  //             return []
  //           })
  //           .catch((error) => {
  //             console.error(`Error fetching data for company ${company.id}:`, error)
  //             return []
  //           }),
  //       )

  //       const results = await Promise.all(fetchPromises)
  //       const allData = [].concat(...results)
  //       setData(allData)

  //       if (allData.length <= 10) {
  //         setPagination(false)
  //       } else {
  //         setPagination(initalState.pagination)
  //       }
  //     }
  //   } catch (error) {
  //     console.error('Error fetching all KPI data:', error)
  //     setData([])
  //   } finally {
  //     setIsLoading(false)
  //   }
  // }

  const fetchAllKPIData = async () => {
    setIsLoading(true)

    try {
      if (dataTree && dataTree.length > 0) {
        const fetchPromises = dataTree.map((company) =>
          getKpitypeByCompanyIdV3({
            company_id: company.id,
            token: token,
          })
            .then((response) => {
              if (response.status === 200) {
                return response.data.result
              }
              return []
            })
            .catch((error) => {
              console.error(`Error fetching data for company ${company.id}:`, error)
              return []
            }),
        )

        const results = await Promise.all(fetchPromises)
        const allData = [].concat(...results)
        setData(allData)

        if (allData.length <= 10) {
          setPagination(false)
        } else {
          setPagination(initalState.pagination)
        }
      }
    } catch (error) {
      console.error('Error fetching all KPI data:', error)
      setData([])
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (filteredKPIs.length > 0) {
      if (filteredKPIs.includes(0)) {
        setFilteredTreeKPI(dataTree)
        fetchAllKPIData()
      } else {
        const filteredTree =
          dataTree && dataTree.length > 0
            ? dataTree.filter((item) => filteredKPIs.includes(item.id))
            : []
        setFilteredTreeKPI(filteredTree)
        if (filteredTree.length > 0) {
          setCompanyID(filteredTree[0].id)
        }
      }
    } else {
      setFilteredTreeKPI(dataTree)
    }
  }, [filteredKPIs, dataTree])

  useEffect(() => {
    if (filterDataKPI.length > 0 && firstTimeFilter) {
      setCompanyID(filterDataKPI[0].id)
    }
  }, [filterDataKPI, firstTimeFilter])

  const fetchResultsCompany = async () => {
    await getResultCompanyV2({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setResultscompany([])

          return true
        }
        if (status === 200) {
          setResultscompany(data.result)
        } else {
          setResultscompany([])
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const roleUser = getCookie('roleUser')
  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 18) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  const getResultTreeKpitype = async () => {
    await getTreeKpitypeV3({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataTree([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          if (firsttimein == true) {
            setCompanyID(data.result[0].id)
          }
          setDataTree(data.result)
          setIsLoading(false)
        } else {
          setDataTree([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataTree([])
        setIsLoading(false)
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      getResultTreeKpitype()
      fetchResultsCompany()
    }
  }, [token])

  const getDataKpitype = async () => {
    await getKpitypeByCompanyIdV3({
      company_id: companyID,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setData([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          if (data.length <= 10) {
            setPagination(false)
          } else {
            setPagination(initalState.pagination)
          }
          setData(data.result)
          setIsLoading(false)
        } else {
          setData([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setData([])
        setIsLoading(false)
        console.error(error)
      })
  }

  // const getDataKpitype = async () => {
  //   await getKpitypeByCompanyIdV2({
  //     company_id: companyID,
  //     token: token,
  //   })
  //     .then(async (response) => {
  //       const { status, data, error } = response
  //       if (error) {
  //         setData([])

  //         setIsLoading(false)
  //         return true
  //       }
  //       if (status === 200) {
  //         console.log('response', response)
  //         if (data.length <= 10) {
  //           setPagination(false)
  //         } else {
  //           setPagination(initalState.pagination)
  //         }
  //         setData(data.result)
  //         setIsLoading(false)
  //       } else {
  //         setData([])

  //         setIsLoading(false)
  //         return true
  //       }
  //     })
  //     .catch((error) => {
  //       setData([])
  //       setIsLoading(false)
  //       console.error(error)
  //     })
  // }
  useEffect(() => {
    if (companyID !== undefined) {
      getDataKpitype()
    }
  }, [companyID])

  const eventAdd = (company_id) => {
    setSwitchValue(true)
    setMainKpiValue(false)
    if (company_id === 0) {
      setSwitchValue(true)
      form.setFieldsValue({
        company_id: null,
        code: null,
        name: null,
        name_en: null,
        status: true,
        main_kpi: false,
        first_formula: null,
        second_formula: null,
        calculate_type: 'cumulative',
        reference_point: 0,
      })
    } else {
      form.setFieldsValue({
        company_id: company_id,
        code: null,
        name: null,
        name_en: null,
        status: true,
        main_kpi: false,
        first_formula: null,
        second_formula: null,
        calculate_type: 'cumulative',
        reference_point: 0,
      })
    }
    setFirsttimein(false)
    setHiddenError(true)
    setVisible(true)
    setStateDrawer('add')
    setTitleDrawer('Add KPI/Finance Type')
  }

  const getDataKpitypeInfo = async (data) => {
    try {
      const response = await getKpitypeInfoByCompanyId({
        id: data.data.id,
        token: token,
      })

      if (response.status === 200) {
        const fullData = response.data.result
        return fullData
      } else {
        console.error('Failed to fetch KPI info:', response)
        return null
      }
    } catch (error) {
      console.error('Error fetching KPI info:', error)
      return null
    }
  }

  const eventEdit = async (data) => {
    permissionPage.update ? setDisablePage(false) : setDisablePage(true)

    let fullData = null

    // ตรวจสอบว่ามี companyID และ id ก่อนเรียก API
    if (
      companyID &&
      companyID !== undefined &&
      data?.data?.id &&
      data.data.id !== undefined
    ) {
      fullData = await getDataKpitypeInfo(data)
    }

    // ใช้ข้อมูลจาก API หากมี หรือข้อมูลเดิมหากไม่มี
    if (fullData) {
      // ใช้ข้อมูลจาก getDataKpitypeInfo
      const isActive = fullData.status === 'Active'
      // service-core returns is_main_kpi as true/false, service-project as 1/0 (Decision 2 = B)
      const isMainKpi = fullData.is_main_kpi === 1 || fullData.is_main_kpi === true

      setSwitchValue(isActive)
      setMainKpiValue(isMainKpi)
      setCalculationType(fullData.calculate_type || 'cumulative')

      form.setFieldsValue({
        company_id: fullData.company?.id || data.data.company_id,
        code: fullData.code,
        name: fullData.name,
        name_en: fullData.name_en,
        status: isActive,
        main_kpi: isMainKpi,
        first_formula: fullData.first_formula || null,
        second_formula: fullData.second_formula || null,
        calculate_type: fullData.calculate_type || 'cumulative',
        reference_point: fullData.reference_point || 0,
      })

      // เก็บข้อมูลครบถ้วนสำหรับการ edit
      setDataEdit({
        ...data,
        fullData: fullData,
      })
    }

    setFirsttimein(false)
    setHiddenError(true)
    setStateDrawer('edit')
    setTitleDrawer('Edit KPI/Finance Type')
    setVisible(true)
  }

  useEffect(() => {
    if (checkChangeTable == 9998) {
      setCheckChangeTable(0)
      getDataKpitype()
    } else if (checkChangeTable > 0) {
      getDataKpitype()
    }
  }, [checkChangeTable])

  // search
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            className="mini-search-btn-admin"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          >
            <SearchOutlined className="icon" />
            {word['Search']}
          </Button>
          <Button
            type="primary"
            className="mini-search-btn-admin-reset"
            onClick={() => handleReset(clearFilters)}
          >
            {word['Reset']}
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    render: (text) => (searchedColumn === dataIndex ? text : text),
  })
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const renderTable = () => {
    let displayData = data

    if (filteredKPIs.length > 0 && !filteredKPIs.includes(0)) {
      displayData = data.filter(
        (item) =>
          filteredKPIs.includes(item.company_id) || filteredKPIs.includes(item.id),
      )
    }

    return (
      <Table
        key={checkChangeTable}
        onRow={(record) => {
          return {
            onClick: () => eventEdit(record), // click row
          }
        }}
        columns={columns}
        dataSource={dataSource}
        onChange={onChange}
        pagination={pagination}
        showSorterTooltip={false}
      />
    )
  }
  const columns = [
    // table impactype
    {
      title: <h5>{word['Business']}</h5>,
      dataIndex: 'company_code',
      ellipsis: true,
      width: 160,
    },
    {
      title: <h5>{word['KPI_Finance_type']}</h5>,
      dataIndex: 'kpi_code',
      sorter: (a, b) => a.kpi_code.localeCompare(b.kpi_code),
      ellipsis: true,
      width: 200,
      ...getColumnSearchProps('kpi_code'),
    },
    {
      title: <h5>{word['Local_KPI_Finance_type_name']}</h5>,
      dataIndex: 'local_name',
      sorter: (a, b) => a.local_name.localeCompare(b.local_name),
      ellipsis: true,
      ...getColumnSearchProps('local_name'),
    },
    {
      title: <h5>{word['English_KPI_Finance_type_name']}</h5>,
      dataIndex: 'english_name',
      sorter: (a, b) => a.english_name.localeCompare(b.english_name),
      ellipsis: true,
      ...getColumnSearchProps('english_name'),
    },
    {
      title: <h5>Status</h5>,
      dataIndex: 'status',
      sorter: (a, b) => a.status.localeCompare(b.status),
      ellipsis: true,
      ...getColumnSearchProps('status'),
    },
  ]
  const dataSource = data.map((item) => ({
    id: item.id,
    company_code: item.company_code,
    kpi_code: item.code,
    local_name: item.name,
    english_name: item.name_en,
    data: item,
    status: item.status,
  }))

  const onFinish = (value) => {
    if (stateDrawer === 'add') {
      const data = {
        company_id: value.company_id,
        code: value.code,
        name: value.name,
        name_en: value.name_en,
        status: value.status ? 'Active' : 'Inactive',
        main_kpi: value.main_kpi ? true : false,
        first_formula: value.main_kpi ? value.first_formula : null,
        second_formula: value.main_kpi ? value.second_formula : null,
        calculate_type: value.main_kpi ? value.calculate_type : null,
        reference_point: value.reference_point || 0,
      }
      try {
        addKpitypeV2({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setHiddenError(true)
            getResultTreeKpitype()
            getDataKpitype()
            setVisible(false)
            setSwitchValue(true)
            setMainKpiValue(false)
          } else {
            if (res.data.errorCode === '2008') {
              setWordERR(word['err_kpi_code'])
            } else {
              setWordERR('error')
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      const data = {
        id: dataEdit.id,
        company_id: value.company_id,
        code: value.code,
        name: value.name,
        name_en: value.name_en,
        status: value.status ? 'Active' : 'Inactive',
        main_kpi: value.main_kpi ? true : false,
        first_formula: value.main_kpi ? value.first_formula : null,
        second_formula: value.main_kpi ? value.second_formula : null,
        calculate_type: value.main_kpi ? value.calculate_type : null,
        reference_point: value.reference_point || 0,
      }
      try {
        updateKpitypeV2({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setHiddenError(true)
            getResultTreeKpitype()
            getDataKpitype()
            setVisible(false)
            setSwitchValue(true)
            setMainKpiValue(false)
          } else {
            if (res.data.errorCode === '2018') {
              setWordERR(word['err_kpi_itemused'])
            } else if (res.data.errorCode === '2008') {
              setWordERR(word['err_kpi_code'])
            } else {
              setWordERR('error')
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  function onChange(pagination2, filters, sorter, extra) {
    if (pagination !== false) {
      setPagination((prevState) => {
        return {
          ...prevState,
          pageSize: pagination2.pageSize,
          current: pagination2.current,
        }
      })
    }
  }

  const renderButton_Drawer = () => {
    if (stateDrawer === 'add') {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button className="BTN_Next" onClick={form.submit}>
            {word['Save']}
          </Button>
        </div>
      )
    } else {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button
            className="BTN_Delete_CPF_RED"
            onClick={() => setVisibleDelete(true)}
            style={{ marginRight: 8 }}
            hidden={permissionPage.delete ? false : true}
          >
            {word['Delete']}
          </Button>
          <Button
            hidden={permissionPage.update ? false : true}
            className="BTN_Next"
            onClick={form.submit}
            type="primary"
          >
            {word['Save']}
          </Button>
        </div>
      )
    }
  }
  const onClose = (value) => {
    setVisible(false)
  }
  const onChangeKpiCode = (e) => {
    form.setFieldsValue({
      code: e.target.value.replace(/\s/g, ''),
    })
  }

  const handleStatusChange = (checked) => {
    form.setFieldsValue({ status: checked })
    setSwitchValue(checked)
    // ไม่ต้องยุ่งกับ mainKpiValue
  }

  const handleMainKpiChange = (checked) => {
    form.setFieldsValue({ main_kpi: checked })
    setMainKpiValue(checked)

    if (checked) {
      // เมื่อเปิด Main KPI ให้ตั้งค่า default
      const currentValues = form.getFieldsValue()
      form.setFieldsValue({
        first_formula: currentValues.first_formula || null,
        second_formula: currentValues.second_formula || null,
        calculate_type: 'cumulative', // default เป็น cumulative
      })
      setCalculationType('cumulative')
    } else {
      // Clear formula fields when Main KPI is turned off
      form.setFieldsValue({
        first_formula: null,
        second_formula: null,
        calculate_type: 'cumulative',
      })
      setCalculationType('cumulative')
    }
  }

  const content = () => {
    if (data.length > 0) {
      return (
        <KPIContainer>
          <Header className="layout-button-add-normal-state">
            <div className="layout-btn-reset-add">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <FilterSearchTree
                  dataItems={dataCompany}
                  selectedItems={filteredKPIs}
                  setSelectedItems={setFilteredKPIs}
                  placeholderText={`Select ${textd}`}
                  itemTypeName="Business"
                  treeId="kpi-type"
                  excludeAllID={false}
                />
                <Button
                  hidden={permissionPage.create ? false : true}
                  onClick={() => eventAdd(companyID)}
                  icon={<PlusOutlined className="Icon-color" />}
                  className="BTN_Next"
                >
                  {word['Add_KPI_Finance_Type']}
                </Button>
                <Button
                  type="primary"
                  style={{ marginLeft: 8 }}
                  className="btn_Secondary2"
                  onClick={() => window.location.reload()}
                >
                  <RedoOutlined className="Icon-color" />
                  {word['Reset']}
                </Button>
              </div>
            </div>
          </Header>
          <Body>{renderTable()}</Body>
        </KPIContainer>
      )
    } else {
      return (
        <EmptyContainer className="initialstate-container">
          <img src={iconEmpty} />
          <h2>{word['Please_add_KPI_finance_type']}</h2>
          <Button
            hidden={permissionPage.create ? false : true}
            onClick={() => eventAdd(companyID)}
            icon={<PlusOutlined className="Icon-color" />}
            className="btn_Secondary2"
          >
            {word['Add_KPI_Finance_Type']}
          </Button>
        </EmptyContainer>
      )
    }
  }
  return (
    <KPIContainer>
      <div className="layoutmanagement-git-master">
        <div className="layout-left">
          <div
            style={{ marginTop: 16, marginBottom: 16, marginLeft: 16, marginRight: 16 }}
          >
            <FilterSearchTree
              dataItems={dataCompany}
              selectedItems={filteredKPIs}
              setSelectedItems={setFilteredKPIs}
              placeholderText={`Select ${textd}`}
              itemTypeName="Business"
              treeId="kpi-type"
              excludeAllID={false}
            />
          </div>
          <Tree
            treeCompany={filteredTreeKPI.length > 0 ? filteredTreeKPI : dataTree}
            setLevel_ID={setLevel_ID}
            setLevel={setLevel}
            eventAdd={eventAdd}
            setCheckByID={setCheckByID}
            setCompanyID={(value) => {
              setCompanyID(value)
              if (filteredKPIs.length > 0) {
                setFirstTimeFilter(false)
              } else {
                setFirstTimeFilter(true)
              }
            }}
            setCheckChangeTable={setCheckChangeTable}
            checkChangeTable={checkChangeTable}
          />
        </div>
        <div className="layout-right">{content()}</div>
      </div>
      <Modal
        maskClosable={false}
        title={<TextTitleBold>{titleDrawer}</TextTitleBold>}
        placement="right"
        onCancel={onClose}
        visible={visible}
        width={'634px'}
        footer={renderButton_Drawer()}
        destroyOnClose
        className="fix-modal"
        centered
      >
        <Form className="disable-page" form={form} layout="vertical" onFinish={onFinish}>
          <fieldset disabled={disablePage}>
            <div hidden={hiddenError} style={{ marginBottom: 10 }}>
              <Alert message={wordERR} type="error" showIcon />
            </div>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="company_id"
                  name="company_id"
                  className="customValidation"
                  label={<h4>{word['Business_Code']}</h4>}
                  rules={[{ required: true, message: 'Please enter business code' }]}
                >
                  <Select
                    showSearch
                    id="select_company_code"
                    size="large"
                    placeholder="Please enter business code"
                    allowClear
                    optionFilterProp="children"
                    disabled={disablePage}
                  >
                    {dataCompany.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.code} {item.name_en}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="code"
                  name="code"
                  label={<h4>{word['KPI_Finance_Type_Code']}</h4>}
                  className="customValidation"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter kpi type code',
                    },
                  ]}
                >
                  <Input
                    id="code"
                    size="large"
                    maxLength={10}
                    onChange={onChangeKpiCode}
                    className="customValidation"
                    onKeyUp={(e) =>
                      form.setFieldsValue({
                        code: toUpper(e.target.value),
                      })
                    }
                    placeholder="Please enter kpi type code"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  id="name"
                  name="name"
                  className="customValidation"
                  label={<h4>{word['Local_KPI_Finance_Type_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter local  name',
                    },
                  ]}
                >
                  <Input id="name" size="large" placeholder="Please enter local name" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  id="name_en"
                  name="name_en"
                  className="customValidation"
                  label={<h4>{word['English_KPI_Finance_Type_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter english  name',
                    },
                  ]}
                >
                  <Input
                    id="name_en"
                    size="large"
                    placeholder="Please enter english name"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="main_kpi">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '8px' }}>Main KPI:</span>
                    <Switch checked={mainKpiValue} onChange={handleMainKpiChange} />
                  </div>
                </Form.Item>
              </Col>
            </Row>
            {mainKpiValue && (
              <>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item
                      id="first_formula"
                      name="first_formula"
                      className="customValidation"
                      label={<h4>{word['Formula_Target_more_than']}</h4>}
                      rules={[
                        {
                          whitespace: true,
                          required: mainKpiValue,
                          message: 'Please enter Formula',
                        },
                      ]}
                    >
                      <Input
                        id="first_formula"
                        size="large"
                        placeholder="Please enter Formula"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item
                      id="second_formula"
                      name="second_formula"
                      className="customValidation"
                      label={<h4>{word['Formula_Target_less_than']}</h4>}
                      rules={[
                        {
                          whitespace: true,
                          required: mainKpiValue,
                          message: 'Please enter Formula',
                        },
                      ]}
                    >
                      <Input
                        id="second_formula"
                        size="large"
                        placeholder="Please enter Formula"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item name="calculate_type" label={<h4>Calculation Type:</h4>}>
                      <Radio.Group
                        block
                        options={[
                          { label: 'Cumulative', value: 'cumulative' },
                          { label: 'Monthly', value: 'monthly' },
                        ]}
                        value={calculateType}
                        onChange={(e) => {
                          setCalculationType(e.target.value)
                          form.setFieldsValue({ calculate_type: e.target.value })
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="status">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '8px' }}>Status Active:</span>
                    <Switch checked={switchValue} onChange={handleStatusChange} />
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Form>
        <DeleteKpitype
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          state={'kpitype'}
          data={dataEdit}
          renderData={getResultTreeKpitype}
          setVisibleDrawer={setVisible}
          setCheckChangeTable={setCheckChangeTable}
        />
      </Modal>
    </KPIContainer>
  )
}
export default KPI
